import useThirdPartyIndicator from './useThirdPartyIndicator';
export default useThirdPartyIndicator;
